import Tooltip from './Tooltip';

export default Tooltip;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.7.2@rc-tooltip/es/index.js
// module id = 320
// module chunks = 1